import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import axios from "axios";
import qs from "qs" ;

export async function getSearchResults(query, nswToken) {
    var data = qs.stringify({
        nsw_access_token: nswToken,
        search_text: query,
    });

    var config = {
        method: "post",
        url: dataProvider.baseUrl + "nswapi-searchText",
        headers: {
            token: authServices.getToken(),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };

    try {
        let response = await axios(config) ;
        if (!response.data.error) {
            let resultCards = new Array(...response.data);
            return [resultCards,null] ;
        } else {
            return [null,response.data.error] ;
        }
    } catch(error){
        return [null,error] ;
    }
}

export async function getNSWToken() {
    var config = {
        method: "get",
        url: dataProvider.baseUrl + "nswapi-getAuthToken",
        headers: {
            token: authServices.getToken(),
        },
    };

    try {
        const response = await axios(config)
        //console.log("NSW RES",response)
        if(response.data.status === "approved") {
            return [response.data,null]
        } else {
            return [null,response.data.error]
        }
    } catch(error) {
        return [null,error]
    }
    
}

// export function validateNSWToken(){
//     let expiryTime = authServices.getNSWAccessTokenExpiry();
//     let now = new Date() ; 

//     if(!expiryTime) 
//         return false ;

//     //console.log("validating : ", now.getTime(),expiryTime)

//     if(expiryTime < now.getTime()) {
//         return false ;
//     } else {
//         return true ;
//     }
// }